import React from "react";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";

const DASHBOARD_TYPOGRAPHY = {
  body: "text-sm font-medium text-white",
};

const AITab = ({ aiAnalysis, aiLoading, fetchAIAnalysis }) => (
  <div className="h-full overflow-auto">
    <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <h3 className="text-sm font-semibold uppercase tracking-[0.18em] text-white/70">AI Market Analysis</h3>
      <Button onClick={fetchAIAnalysis} disabled={aiLoading} className="bg-white/10 text-white hover:bg-white/20">
        {aiLoading ? "Analyzing..." : "Update Analysis"}
      </Button>
    </div>

    {aiAnalysis ? (
      <Card className="bg-white/5 border-white/10">
        <CardContent className="p-4">
          <div className="space-y-4">
            <div className="flex flex-wrap items-center gap-2 text-xs">
              <Badge className={`${aiAnalysis.analysis_source === "llm" ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" : "bg-amber-500/15 text-amber-300 border-amber-500/30"}`}>
                {aiAnalysis.analysis_source === "llm" ? "LLM" : "Rule Fallback"}
              </Badge>
              {aiAnalysis.llm_provider ? (
                <Badge className="bg-white/10 text-white/80 border-white/10">
                  {aiAnalysis.llm_provider}
                </Badge>
              ) : null}
              {aiAnalysis.llm_model ? (
                <Badge className="bg-white/10 text-white/60 border-white/10">
                  {aiAnalysis.llm_model}
                </Badge>
              ) : null}
            </div>

            {aiAnalysis.llm_error ? (
              <div className="rounded-lg border border-amber-500/20 bg-amber-500/10 p-3 text-xs text-amber-200">
                LLM fallback reason: {aiAnalysis.llm_error}
              </div>
            ) : null}

            {aiAnalysis.analysis_source === "llm" ? (
              <>
                <div>
                  <h4 className={`${DASHBOARD_TYPOGRAPHY.body} mb-2`}>Market Summary</h4>
                  <p className="text-sm leading-6 text-white/80">{aiAnalysis.summary}</p>
                </div>
                <div>
                  <h4 className={`${DASHBOARD_TYPOGRAPHY.body} mb-2`}>Trading Recommendation</h4>
                  <p className="text-sm leading-6 text-white/80">{aiAnalysis.recommendation}</p>
                </div>
                {aiAnalysis.key_levels?.length ? (
                  <div>
                    <h4 className={`${DASHBOARD_TYPOGRAPHY.body} mb-2`}>Key Levels</h4>
                    <ul className="list-disc list-inside text-sm leading-6 text-white/80">
                      {aiAnalysis.key_levels.map((level, idx) => <li key={idx}>{level}</li>)}
                    </ul>
                  </div>
                ) : null}
                {aiAnalysis.rationale?.length ? (
                  <div>
                    <h4 className={`${DASHBOARD_TYPOGRAPHY.body} mb-2`}>Rationale</h4>
                    <ul className="list-disc list-inside text-sm leading-6 text-white/80">
                      {aiAnalysis.rationale.map((reason, idx) => <li key={idx}>{reason}</li>)}
                    </ul>
                  </div>
                ) : null}
              </>
            ) : (
              <>
                <div>
                  <h4 className={`${DASHBOARD_TYPOGRAPHY.body} mb-2`}>Market Summary</h4>
                  <p className="text-sm leading-6 text-white/80">{aiAnalysis.summary}</p>
                </div>
                <div>
                  <h4 className={`${DASHBOARD_TYPOGRAPHY.body} mb-2`}>Key Levels</h4>
                  <ul className="list-disc list-inside text-sm leading-6 text-white/80">
                    {aiAnalysis.key_levels?.map((level, idx) => (
                      <li key={idx}>{level}</li>
                    ))}
                  </ul>
                </div>
                <div>
                  <h4 className={`${DASHBOARD_TYPOGRAPHY.body} mb-2`}>Trading Recommendation</h4>
                  <p className="text-sm leading-6 text-white/80">{aiAnalysis.recommendation}</p>
                </div>
              </>
            )}
          </div>
        </CardContent>
      </Card>
    ) : (
      <div className="text-center py-8 text-white/70">
        Click "Update Analysis" to generate AI insights
      </div>
    )}
  </div>
);

export default React.memo(AITab);
